var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dot",staticClass:"picnic_team_dot",class:{
    'is-active': _vm.isActive,
    'ps-is-mine': _vm.isMine,
    'is-create-mode': _vm.isCreateMode,
    'is-hidden': _vm.activeId && !_vm.isActive
  },style:(_vm.style),attrs:{"data-picnic-id":_vm.id,"aria-label":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.launchCard($event)},"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_c('div',{staticClass:"ps-glow"}),(_vm.isActive || _vm.isCreateMode)?_c('the-notation',{attrs:{"type":_vm.dot.notation,"selector":_vm.selector}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }